import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Typography } from "@parkschannel/ui";
import { TruncatedTagsList } from "../../Tags";
import { UserWebsites } from "./UserWebsites";
import { SocialLinks } from "../SocialLinks";
export const UserInfoContent = (param)=>{
    let { user , subscribeButton  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-full text-center mt-4 md:text-left md:mt-0",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                component: "h1",
                variant: "h2",
                className: "text-neutral-900max-w-full line-clamp-1 break-all",
                children: user.name
            }),
            /*#__PURE__*/ _jsxs(Typography, {
                component: "p",
                variant: "captionBase",
                className: "text-neutral-600 mb-4 ",
                children: [
                    user.subscriptionsCount,
                    " subscribers"
                ]
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "bodyBase",
                className: "text-neutral-600 mb-4",
                children: user.description
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mb-3 mx-auto max-w-[90%] md:mx-0 lg:max-w-[400px]",
                children: /*#__PURE__*/ _jsx(TruncatedTagsList, {
                    tags: user.tags,
                    className: "justify-center md:justify-start"
                })
            }),
            /*#__PURE__*/ _jsx(UserWebsites, {
                user: user
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col items-center gap-2 mx-auto w-full md:mx-0 md:justify-between md:flex-row md:pr-2",
                children: [
                    /*#__PURE__*/ _jsx(SocialLinks, {
                        user: user
                    }),
                    subscribeButton
                ]
            })
        ]
    });
};
